export default __webpack_public_path__ + "static/taskdefinition13-90ed12be2e5ccd79e098eeac863e9b68.png";